import {Button} from "antd";
import styled from "styled-components";

export const Wrapper = styled.div`
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // blur overlay
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(10px);
    padding: 50px;

    & > div {
        width: 100%;
        max-width: 800px;
        background-color: white;
        padding: 50px;
        border-radius: 10px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        font-size: 20px;
        text-align: center;
    }
`;

export const StyledButton = styled(Button)`
    background-color: black;
    color: white;
    border: none;
    margin-top: 40px;
    width: auto;
    height: auto;
    padding: 20px 40px;
    border-radius: 10px;
    &:focus,
    &:hover,
    &:active {
        background-color: #4d4d4d;
        color: white;
    }
`;
